import AsyncSelect, { Option } from "../../../components/AsyncSelect";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import { HourAllocationTypeService } from "@/modules/projects/service/hourAllocationType";
import appConfiguration from "@/components/cfg/AppCfg";

interface HourAllocationTypeSelectProps extends ControllerRenderProps {
  className?: string;
  inDialog?: boolean;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, HourAllocationTypeSelectProps>(
  function HourAllocationTypeSelect({ value, defaultItem, ...props }, ref) {
    const { t } = useTranslation();

    return (
      <AsyncSelect
        queryKey={["hourAllocationType"]}
        queryFn={async () => {
          const list = await HourAllocationTypeService.getList({
            limit: appConfiguration.selectComponentsPaginationLimit,
          });
          return {
            items: list.map((item) => ({
              id: item,
              name: t(`hourAllocationType.${item}`),
            })),
            count: list.length,
          };
        }}
        placeholder={t("hourAllocationType.placeholder")}
        loadingLabel={t("hourAllocationType.loading")}
        {...props}
        value={value ? value.toString() : undefined}
        ref={ref}
        enableFilter={false}
        defaultItem={defaultItem}
      />
    );
  },
);
